import { render, staticRenderFns } from "./comTypeApplyForm.vue?vue&type=template&id=5984e8aa&scoped=true"
import script from "./comTypeApplyForm.vue?vue&type=script&lang=js"
export * from "./comTypeApplyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5984e8aa",
  null
  
)

export default component.exports